import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI, showNotification } from 'sonata-react-components';

import { exportAppSiteList } from '../helpers/appSiteListExport.helper';

import type { AppSiteListExportData } from '../../AppAndSiteMarketplace.types';

type Props = {
  disabled: boolean;
  id: string;
  /** Returns the lists to export. */
  getData: () => AppSiteListExportData;
};

/** "Download list" button that exports all the included and excluded items of the tab. */
export function InventoryListDownload({ disabled, getData, id }: Props) {
  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      await exportAppSiteList(getData());
    } catch {
      showNotification(
        'error',
        formatMessage({
          defaultMessage: 'There was an error generating the file. Please try again later.',
          id: 'appAndSiteMarketplace.inventory.download.error'
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ButtonUI
      disabled={disabled}
      icon="fa-regular fa-file-arrow-down"
      id={`${id}_downloadButton`}
      loading={isLoading}
      onClick={handleDownload}
      shape="squareRounded"
      size="ultraSmall"
      text={formatMessage({
        defaultMessage: 'Download list',
        id: 'appAndSiteMarketplace.inventory.download.button'
      })}
      type="secondary"
    />
  );
}
